<div class="enrollement-details-container">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <div class="header">
        <div class="nav-title">
            <div class="back" (click)="back()"
                [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
                <img src="../../../../assets/icons/dashboard/back.svg" alt="">
            </div>
            <div class="title">
                {{'buses.enroll-bus.enroll-details.title' | translate}} ({{allStudents.length |arabicNumber:currLang}})
            </div>

        </div>
    </div>

    <div class="nav-wrapper">
        <div class="tab-nav" [ngClass]="{ active: activeTab === 'success' }" (click)="setActiveTab('success')">
            <!-- <div class="circle success"></div> -->
            <div class="title">
                {{ 'buses.enroll-bus.enroll-details.sucessful-enrolment-title' | translate }}
            </div>
            <div class="count">
                ({{successStudents.length |arabicNumber:currLang}})
            </div>
        </div>
        <div class="tab-nav" [ngClass]="{ active: activeTab === 'failed' }" (click)="setActiveTab('failed')">
            <!-- <div class="circle fail"></div> -->
            <div class="title">
                {{ 'buses.enroll-bus.enroll-details.failed-enrollement-title' | translate }}
            </div>
            <div class="count">
                ({{failStudents.length |arabicNumber:currLang}})
            </div>
        </div>
    </div>


    <div class="erollement-details-wrapper">
        <div class="sucess-section" *ngIf="successStudents.length > 0 && activeTab === 'success'">
            <div class="enroll-details" *ngFor="let student of successStudents">
                <div class="enroll-detail-card success">
                    <!-- <div class="status">
                        {{'buses.enroll-bus.enroll-details.sucess' | translate}}
                    </div> -->

                    <div class="body-wrapper">
                        <div class="student-info-container">
                            <div class="image">
                                <img [src]="baseUrl+student.image_path" alt="">
                            </div>
                            <div class="student-info">
                                <div class="name info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.student-name' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.name}}
                                    </div>
                                </div>
                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.national-id' | translate}}
                                    </div>
                                    <div class="value" data-pii="redact">
                                        {{student?.national_id}}
                                    </div>
                                </div>

                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.grade' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.class?.grade?.name}}
                                    </div>
                                </div>
                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.class' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.class?.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="msg-container">
                            {{'buses.enroll-bus.enroll-details.sucess-msg' | translate}}
                        </div> -->
                    </div>


                </div>
            </div>
        </div>

        <div class="fail-section" *ngIf="failStudents.length > 0 && activeTab === 'failed'">
            <div class="enroll-details" *ngFor="let student of failStudents">
                <div class="enroll-detail-card fail">
                    <!-- <div class="status">
                        {{'buses.enroll-bus.enroll-details.sucess' | translate}}
                    </div> -->


                    <div class="body-wrapper">
                        <div class="student-info-container">
                            <div class="image">
                                <img [src]="baseUrl+student.image_path" alt="">
                            </div>
                            <div class="student-info">
                                <div class="name info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.student-name' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.name}}
                                    </div>
                                </div>
                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.national-id' | translate}}
                                    </div>
                                    <div class="value" data-pii="redact">
                                        {{student?.national_id}}
                                    </div>
                                </div>
                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.grade' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.class?.grade?.name}}
                                    </div>
                                </div>
                                <div class="national-id info">
                                    <div class="label">
                                        {{'buses.enroll-bus.enroll-details.class' | translate}}
                                    </div>
                                    <div class="value">
                                        {{student?.class?.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="msg-container">
                            {{'buses.enroll-bus.enroll-details.failed-msg' | translate}}
                        </div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>